import { Button, IconButton } from "@chakra-ui/react";
import React, { useState } from "react";
import { RiEyeLine } from "react-icons/ri";
import { useSelector, useDispatch } from "react-redux";
import CTable from "../../../components/Table/table";
import { addViewRequest } from "../../../modules/admin-modules/videos/Actions";

const ViewsTable = ({ videoName }) => {
    const userVideos = useSelector((state) => state.videos.userVideos);
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.videos.isLoading);
    const [offset, setPage] = useState(0);
    const [size, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(0);

    const handleAddView = (id) => {
        dispatch(addViewRequest({ id: id }));
    };

    // Filter videos by video name
    const filteredVideos = userVideos?.filter((data) => {
        if (!videoName) return true;
        const videoTitle = data?.video?.title || "";
        return videoTitle.toLowerCase().includes(videoName.toLowerCase());
    });

    const Data = filteredVideos?.map((data) => {
        return {
            ...data,
            id: data?.id,
            video_title: data?.video?.title || "غير محدد",
            user_name: data?.user?.name || "غير محدد",
            user_phone: data?.user?.phone || "غير محدد",
            views_count: data?.views_count || 0,
            add_view: (
                <Button
                    leftIcon={<RiEyeLine />}
                    colorScheme="blue"
                    size="sm"
                    onClick={() => handleAddView(data.id)}
                    isLoading={isLoading}
                >
                    إضافة مشاهدة
                </Button>
            ),
        };
    });

    const columns = [
        {
            Header: "عنوان الفيديو",
            accessor: "video_title",
        },
        {
            Header: "اسم المستخدم",
            accessor: "user_name",
        },
        {
            Header: "رقم الهاتف",
            accessor: "user_phone",
        },
        {
            Header: "عدد المشاهدات",
            accessor: "views_count",
        },
        {
            Header: "إضافة مشاهدة",
            accessor: "add_view",
        },
    ];

    return (
        <CTable
            Columns={columns}
            Data={Data}
            path={"openModel"}
            Actions
            Title={``}
            subTitle=""
            btnTitle=""
            placeHolder=""
            noSearchBar={true}
            noFilter={true}
            footerBtnTitle
            filterList
            addButton
            addButtonTitle=""
            setPage={setPage}
            setPerPage={setPerPage}
            currentpage={pageNumber}
            setPageNumber={setPageNumber}
            noSecondSearchBar={true}
            isLoading={isLoading}
            perPage={size}
            totalPage={Math.ceil((filteredVideos?.length || 0) / 10)}
        />
    );
};

export default ViewsTable; 